import { Button } from "@joonapp/web-shared"
import { useRef } from "react"

const AddAttachmentButton = ({
  attachments,
  setAttachments,
}: {
  attachments: File[]
  setAttachments: (attachments: File[]) => void
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files || !event.target.files[0]) return
    setAttachments([...attachments, ...event.target.files])
    event.target.value = ""
  }

  return (
    <>
      <Button
        size="small"
        text="Add image or pdf"
        buttonType="secondary"
        onClick={() => fileInputRef.current?.click()}
      />
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*,video/*,application/pdf"
        style={{ display: "none" }}
        onChange={handleFileSelect}
      />
    </>
  )
}

export default AddAttachmentButton
